var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }